/**
 * https://gist.github.com/realmyst/1262561
 *
 * const apples = declOfNum(['Яблоко','Яблока','Яблок']);
 * apples(0); // Яблок
 * apples(1); // Яблоко
 * apples(2); // Яблока
 */

/* eslint no-nested-ternary:1 */
function declOfNum(titles: any) {
    return function (n: number) {
        return titles[
            n % 10 === 1 && n % 100 !== 11
                ? 0
                : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20)
                ? 1
                : 2
        ];
    };
}
export default declOfNum;
